import { ArrowRight } from "lucide-react";
import { openModal } from "./data";
import { Eyebrow, Magnetic, MaskLines, Reveal } from "./ui-bits";

const FinalCTA = () => (
  <section id="contact" className="relative overflow-hidden bg-obsidian" data-testid="final-cta-section">
    <div
      aria-hidden
      className="text-outline-ivory pointer-events-none absolute -bottom-8 left-0 select-none whitespace-nowrap font-serif text-[20vw] leading-none"
    >
      ELEVATE
    </div>
    <div className="relative mx-auto max-w-[1440px] px-5 py-28 md:px-10 md:py-44">
      <Eyebrow tone="champagne">Your next move starts here</Eyebrow>
      <h2 className="mt-8 font-serif text-4xl leading-[1.0] text-ivory sm:text-5xl lg:text-6xl">
        <MaskLines
          lines={[
            "LET'S FIND",
            "YOUR NEXT",
            <span key="o" className="italic">OPPORTUNITY.</span>,
          ]}
        />
      </h2>
      <Reveal delay={0.25}>
        <p className="mt-8 max-w-lg text-sm leading-relaxed text-stone md:text-base">
          Whether you're searching for your next location or looking for the
          right occupier for your property, let's start a conversation.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Magnetic>
            <button
              type="button"
              onClick={() => openModal("find")}
              className="group inline-flex items-center gap-3 bg-ivory px-7 py-4 text-[12px] font-medium uppercase tracking-[0.22em] text-obsidian transition-colors duration-500 hover:bg-champagne"
              data-testid="final-find-space-btn"
            >
              Find a Space
              <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1" />
            </button>
          </Magnetic>
          <Magnetic>
            <button
              type="button"
              onClick={() => openModal("list")}
              className="group inline-flex items-center gap-3 border border-ivory/30 px-7 py-4 text-[12px] font-medium uppercase tracking-[0.22em] text-ivory transition-colors duration-500 hover:border-champagne hover:text-champagne"
              data-testid="final-list-property-btn"
            >
              List Your Property
              <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1" />
            </button>
          </Magnetic>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
